import React from 'react';
import ImageLightboxItem from './ImageLightboxItem';
import LightboxProvider from './LightboxProvider';

const LightboxLoadable = ({ images, name, children }) => (
  <LightboxProvider>
    {images &&
      !!images.length &&
      images.map((item, key) => (
        <ImageLightboxItem
          key={key.toString()}
          image={item}
          caption={item.description || name}
          group={name}
        >
          {item.children}
        </ImageLightboxItem>
      ))}
    {children}
  </LightboxProvider>
);

export default LightboxLoadable;
